import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useClinic } from '@/hooks/use-clinic'
import PrescriptionSheet from '@/components/prescriptions/prescription-sheet'

interface PrintPortalProps {
    prescriptionId: string
}

const PrintPortal: FC<PrintPortalProps> = ({ prescriptionId }): ReactNode => {
    const { data, index, today } = useClinic()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    const prescription = index.prescriptionsById.get(prescriptionId)
    const patient = prescription ? index.patientsById.get(prescription.patientId) : undefined

    if (!mounted || !prescription || !patient) return null

    const consultation = prescription.consultationId ? index.consultationsById.get(prescription.consultationId) ?? null : null

    return createPortal(
        <div className='print-root'>
            <PrescriptionSheet
                prescription={prescription}
                patient={patient}
                consultation={consultation}
                settings={data.settings}
                today={today}
            />
        </div>,
        document.body
    )
}

export default PrintPortal
